export default "__VITE_ASSET__51b9924e__"